var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        staticClass: "mt-3 table-stats",
        attrs: {
          fields: _vm.fields,
          items: _vm.workerStatsTable,
          "show-empty": "",
          "empty-text":
            "Подтверждённых работником заказов за выбранный период не найдено",
          striped: "",
          "foot-clone": ""
        },
        scopedSlots: _vm._u([
          {
            key: "[date]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$moment(data.value).format("DD.MM.YYYY")) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "[]",
            fn: function(data) {
              return [
                _vm._v("\n      " + _vm._s(data.value.toFixed(2)) + "\n    ")
              ]
            }
          },
          {
            key: "[orderCount]",
            fn: function(data) {
              return [_vm._v("\n      " + _vm._s(data.value) + "\n    ")]
            }
          },
          {
            key: "[motivateProducts]",
            fn: function(data) {
              return [_vm._v("\n      " + _vm._s(data.value) + "\n    ")]
            }
          },
          {
            key: "FOOT[date]",
            fn: function(data) {
              return [_vm._v("\n      Итого:\n    ")]
            }
          },
          {
            key: "FOOT[orderSum]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.workerStatsSummary.orderSum.toFixed(2)) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "FOOT[orderCount]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.workerStatsSummary.orderCount) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "FOOT[price]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.workerStatsSummary.price.toFixed(2)) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "FOOT[priceMotivate]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.workerStatsSummary.priceMotivate.toFixed(2)) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "FOOT[motivateProducts]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.workerStatsSummary.motivateProducts) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "FOOT[total]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.workerStatsSummary.total.toFixed(2)) +
                    "\n    "
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d259157e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d259157e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkerStats.vue
// module id = null
// module chunks = 